import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export const FormInputRadio = props => {
  const { control, watch } = useFormContext();

  const defaultValue = watch(props.name) || props.value; // Get the default value from watch()

  return (
    <Controller
      control={control}
      name={props.name}
      defaultValue={defaultValue}
      render={({ field }) => (
        <RadioGroup
          row
          value={field.value}
          onBlur={field.onBlur}
          onChange={e => {
            if (props.handleChange) props.handleChange(e);
            field.onChange(e);
          }}
        >
          {field.value != undefined && field.value != null && (
            <>
              <FormControlLabel value={true} control={<Radio disabled={props.disabled} />} label="Yes" />
              <FormControlLabel value={false} control={<Radio disabled={props.disabled} />} label="No" />
            </>
          )}
        </RadioGroup>
      )}
    />
  );
};
